// extracted by mini-css-extract-plugin
export var container = "navbar-module--container--WSrYO";
export var title = "navbar-module--title---jsQE";